import { Box, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { t } from 'i18next';

interface IProps {
	email: string | null;
}

export function NoAvailabilityBanner(props: IProps) {
	if (!props.email) {
		return null;
	}

	return (
		<Box p={4} bg="gray.50" borderWidth={1} borderColor="gray.400" borderRadius="md">
			<Text fontWeight={500}>{t('This user has not shared any availability with you.')}</Text>
			<UnorderedList my={4} px={4}>
				<ListItem>{t('Ensure the user has an account.')}</ListItem>

				<ListItem>{t('Add the user to a team.')}</ListItem>

				<ListItem>{t('Ask the user to share an availability with the team.')}</ListItem>
			</UnorderedList>

			<Text textAlign="right" fontSize="small">
				{t('We are working to simplify this process 🙏')}
			</Text>
		</Box>
	);

	// return (
	// 	<FormControl mt={4}>
	// 		<FormLabel>{t('Availability')}</FormLabel>
	// 		<InputGroup>
	// 			<Input isDisabled value={props.email} type="email"></Input>
	// 			<InputRightElement w="auto">
	// 				<Button borderLeftRadius={0} type="submit" colorScheme="primary">
	// 					{t('Invite')}
	// 				</Button>
	// 			</InputRightElement>
	// 		</InputGroup>
	// 		<FormHelperText></FormHelperText>
	// 	</FormControl>
	// );
}
